import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { Box } from '@chakra-ui/react';
import { Channel } from '@whitbread-eos/api';
import { Alert, Info, Notification } from '@whitbread-eos/atoms';
import { isStringValid, useSemanticTypography } from '@whitbread-eos/utils';
import { jsx as _jsx } from "react/jsx-runtime";
export var INFO_NOTIFICATION_TYPE = 'info';
export var WARNING_NOTIFICATION_TYPE = 'warning';
export var AnnouncementNotification = _ref => {
  var _announcement$bbText$, _announcement$bbText, _announcement$text$re, _announcement$text;
  var announcement = _ref.announcement,
    styles = _ref.styles,
    channel = _ref.channel,
    _ref$arrivalDate = _ref.arrivalDate,
    arrivalDate = _ref$arrivalDate === void 0 ? '' : _ref$arrivalDate,
    _ref$departureDate = _ref.departureDate,
    departureDate = _ref$departureDate === void 0 ? '' : _ref$departureDate;
  var getTypographyProps = useSemanticTypography();
  var announcementDescriptionTypographyProps = getTypographyProps(announcementDescriptionLegacyTypography, announcementDescriptionSemanticTypography);
  var announcementDescriptionTextStyle = 'textStyle' in announcementDescriptionTypographyProps ? announcementDescriptionTypographyProps.textStyle : undefined;
  if (!announcement || (announcement === null || announcement === void 0 ? void 0 : announcement.showAnnouncement) !== 'true' || !announcementOverlapsWithStay(arrivalDate, departureDate) || !isStringValid(announcement.text)) {
    return null;
  }
  return _jsx(Box, {
    mt: {
      base: 'md',
      lg: 'lg'
    },
    "data-testid": "announcement-notification-".concat(announcement.type),
    children: _jsx(Notification, _objectSpread(_objectSpread(_objectSpread({
      title: announcement.title,
      description: channel === Channel.Bb ? (_announcement$bbText$ = announcement === null || announcement === void 0 || (_announcement$bbText = announcement.bbText) === null || _announcement$bbText === void 0 ? void 0 : _announcement$bbText.replace(/href="\//g, 'href="https://www.premierinn.com/')) !== null && _announcement$bbText$ !== void 0 ? _announcement$bbText$ : '' : (_announcement$text$re = announcement === null || announcement === void 0 || (_announcement$text = announcement.text) === null || _announcement$text === void 0 ? void 0 : _announcement$text.replace(/href="\//g, 'href="https://www.premierinn.com/')) !== null && _announcement$text$re !== void 0 ? _announcement$text$re : ''
    }, getNotificationPropsByType()), _objectSpread(_objectSpread({}, notificationStyles), styles)), {}, {
      descriptionTextStyle: announcementDescriptionTextStyle,
      prefixDataTestId: "announcement-notification-".concat(announcement.type),
      sx: {
        a: {
          color: 'darkGrey1',
          textDecoration: 'underline'
        }
      },
      isInnerHTML: true
    }))
  });
  function getNotificationPropsByType() {
    if ((announcement === null || announcement === void 0 ? void 0 : announcement.type) === INFO_NOTIFICATION_TYPE) {
      return {
        variant: 'info',
        status: 'info',
        svg: _jsx(Info, {})
      };
    }
    if ((announcement === null || announcement === void 0 ? void 0 : announcement.type) === WARNING_NOTIFICATION_TYPE) {
      return {
        variant: 'alert',
        status: 'warning',
        svg: _jsx(Alert, {})
      };
    }
    return {
      variant: 'info',
      status: 'info',
      svg: _jsx(Info, {})
    };
  }
  function announcementOverlapsWithStay(arrivalDate, departureDate) {
    var _announcement$startDa, _announcement$startDa2, _announcement$endDate, _announcement$endDate2;
    if (!announcement || !arrivalDate || !departureDate) return false;
    var _ref2 = (_announcement$startDa = announcement === null || announcement === void 0 || (_announcement$startDa2 = announcement.startDate) === null || _announcement$startDa2 === void 0 || (_announcement$startDa2 = _announcement$startDa2.split('/')) === null || _announcement$startDa2 === void 0 ? void 0 : _announcement$startDa2.map(s => +s)) !== null && _announcement$startDa !== void 0 ? _announcement$startDa : [],
      _ref3 = _slicedToArray(_ref2, 3),
      startDateDay = _ref3[0],
      startDateMonth = _ref3[1],
      startDateYear = _ref3[2];
    var _ref4 = (_announcement$endDate = announcement === null || announcement === void 0 || (_announcement$endDate2 = announcement.endDate) === null || _announcement$endDate2 === void 0 || (_announcement$endDate2 = _announcement$endDate2.split('/')) === null || _announcement$endDate2 === void 0 ? void 0 : _announcement$endDate2.map(s => +s)) !== null && _announcement$endDate !== void 0 ? _announcement$endDate : [],
      _ref5 = _slicedToArray(_ref4, 3),
      endDateDay = _ref5[0],
      endDateMonth = _ref5[1],
      endDateYear = _ref5[2];
    var startTime = new Date(startDateYear, startDateMonth - 1, startDateDay).getTime();
    var endTime = new Date(endDateYear, endDateMonth - 1, endDateDay).getTime();
    if (arrivalDate && departureDate) {
      var _arrivalDate$split$ma, _arrivalDate$split, _departureDate$split$, _departureDate$split;
      var _ref6 = (_arrivalDate$split$ma = arrivalDate === null || arrivalDate === void 0 || (_arrivalDate$split = arrivalDate.split('-')) === null || _arrivalDate$split === void 0 ? void 0 : _arrivalDate$split.map(s => +s)) !== null && _arrivalDate$split$ma !== void 0 ? _arrivalDate$split$ma : [],
        _ref7 = _slicedToArray(_ref6, 3),
        arrivalYear = _ref7[0],
        arrivalMonth = _ref7[1],
        arrivalDay = _ref7[2];
      var _ref8 = (_departureDate$split$ = departureDate === null || departureDate === void 0 || (_departureDate$split = departureDate.split('-')) === null || _departureDate$split === void 0 ? void 0 : _departureDate$split.map(s => +s)) !== null && _departureDate$split$ !== void 0 ? _departureDate$split$ : [],
        _ref9 = _slicedToArray(_ref8, 3),
        departureYear = _ref9[0],
        departureMonth = _ref9[1],
        departureDay = _ref9[2];
      var arrivalTime = new Date(arrivalYear, arrivalMonth - 1, arrivalDay).getTime();
      var departureTime = new Date(departureYear, departureMonth - 1, departureDay).getTime();
      return startTime <= arrivalTime && arrivalTime <= endTime || startTime <= departureTime && departureTime <= endTime || arrivalTime <= startTime && endTime <= departureTime;
    }
    var currentTime = new Date().getTime();
    return startTime <= currentTime && currentTime <= endTime;
  }
};
var notificationStyles = {
  maxW: {
    base: 'full'
  },
  lineHeight: '2'
};
var announcementDescriptionLegacyTypography = {};
var announcementDescriptionSemanticTypography = {
  textStyle: 'body-s-regular'
};